import React, { useRef } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { motion, useInView } from "framer-motion";

// ✅ Image imports - all PNGs
import CertificationOne from "../assets/images/CertificationOne.png";
import CertificationTwo from "../assets/images/CertificationTwo.png";
import CertificationThree from "../assets/images/CertificationThree.png";
import CertificationFour from "../assets/images/CertificationFour.png";
import CertificationFive from "../assets/images/CertificationFive.png";

import "../assets/styles/HeroSection.css";

// ✅ Certification array with images only
const certifications = [
  { id: 1, title: "Kosher Certification", image: CertificationOne },
  { id: 2, title: "Organic Certification", image: CertificationTwo },
  { id: 3, title: "Halal Certification", image: CertificationThree },
  { id: 4, title: "Fair Trade Certified", image: CertificationFour },
  { id: 5, title: "Non-GMO Verified", image: CertificationFive },
];

// Animation Variants
const textVariantsLeft = {
  hidden: { opacity: 0, x: -50 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const textVariantsRight = {
  hidden: { opacity: 0, x: 50 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut", delay: 0.2 } },
};

const imageVariants = {
  hidden: { opacity: 0, scale: 0.8, y: 20 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

const CertificationSection = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { triggerOnce: false, margin: "-100px" });

  return (
    <Box
      sx={{
        backgroundColor: "#121212",
        color: "white",
        textAlign: "center",
        paddingTop: "20px",
        paddingBottom: "20px",
      }}
    >
      <Box
        ref={sectionRef}
        sx={{
          backgroundColor: "#121212",
          color: "white",
          p: 3,
          textAlign: "center",
        }}
      >
        {/* Heading Section */}
        <Grid container spacing={2} alignItems="center" justifyContent="center">
          <Grid item xs={12} md={6}>
            <motion.div
              variants={textVariantsLeft}
              initial="hidden"
              animate={isInView ? "visible" : "hidden"}
            >
              <Typography className="Who-heading" sx={{ textAlign: { xs: "center", md: "left" } }}>
                Our Commitment To <br /> Quality And Integrity
              </Typography>
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6}>
            <motion.div
              variants={textVariantsRight}
              initial="hidden"
              animate={isInView ? "visible" : "hidden"}
            >
              <Typography
                variant="body1"
                sx={{
                  opacity: 0.8,
                  maxWidth: "600px",
                  textAlign: { xs: "center", md: "left" },
                }}
                className="Who-subheading"
              >
                At Lirio Blanco, we uphold the highest standards in sourcing and production,
                ensuring every product meets rigorous certifications that reflect our dedication to
                sustainability, ethics, and excellence.
              </Typography>
            </motion.div>
          </Grid>
        </Grid>

        {/* Certification Icons Grid */}
        <Grid container spacing={4} justifyContent="center" sx={{ mt: 4 }}>
          {certifications.map((cert, index) => (
            <Grid item xs={6} sm={4} md={2.4} key={cert.id}>
              <motion.div
                variants={imageVariants}
                initial="hidden"
                animate={isInView ? "visible" : "hidden"}
                transition={{ delay: index * 0.2 }}
              >
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Box sx={{ width: 100, height: 100 }}>
                    <img
                      src={cert.image}
                      alt={cert.title}
                      style={{ width: "100%", height: "100%", objectFit: "contain" }}
                    />
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default CertificationSection;
